<script setup>
import { onMounted } from "vue";
import { useStore } from "vuex";
import MainHeader from "@/components/MainHeader.vue";
import AutoLogoutLoadingOverlay from "@/components/AutoLogoutLoadingOverlay.vue";
import { checkAutoLogoutOnStartup, setupAutoLogout } from "@/utils/autoLogout";

const store = useStore();

onMounted(() => {
  checkAutoLogoutOnStartup();
  if (store.getters["authModule/isAuthenticated"]) {
    setupAutoLogout();
  }
});
</script>

<template>
  <AutoLogoutLoadingOverlay />
  <MainHeader />
  <div id="app">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
